// Rename way.startElementId, way.startElementChange, ... -> startItemChange, startItemId, ...
export default {
  applyToVersions: "<2.6.0",
  type: "before",
  name: "move way.startElementId -> way.startItemId (etc.)",
  migrate(data) {
    if (data.ways == null) {
      return data;
    }

    for (const wayId in data.ways.items) {
      const way = data.ways.items[wayId];
      if ("startItemId" in way) return data;
      way.startItemId = way.startElementId;
      way.startItemType = "element";
      way.startItemChange = way.startElementChange;

      delete way.startElementChange;
      delete way.startElementId;
    }

    return data;
  }
};
